import Section from '~/components/hero/LandingPage/Section';
import { TOURNAMENTS } from '~/constants';
import { useGameContext } from '~/contextProviders/GameContextProvider';

export default function BattleHero() {
  const { tournamentParam } = useGameContext();
  const tournamet = TOURNAMENTS[tournamentParam];
  return (
    <Section className="landing-page__section--hero page--battles">
      <div className="main-logo">
        <h2 className="landing-page__h2 landing-page__h2--amarante naming-title-spacing">
          {tournamet?.name}
        </h2>
      </div>

      <div className="clouds clouds--hero clouds--front">
        <img src={`/img/bi-weekly/floating/${tournamet.id}-front.png`} alt="Clouds" />
      </div>
      {/* <div className="clouds clouds--hero clouds--front">
        <img src={`/img/bi-weekly/floating/${tournamet.id}-reversed.png`} alt="Clouds" />
      </div> */}
    </Section>
  );
}
